// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 fill=%27none%27 stroke=%27%236b7280%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feed-tag-view {
  width: 100%;
  max-width: 600px;
  padding: 0 0 40px 0;
}

.feed-tag-header {
  padding: 20px 16px 16px;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 8px;
}

.sidebar-header-bar .header-title.feed-tag-hashtag {
  margin: 0 !important;
  font-size: 26px;
  font-weight: 800;
  color: var(--primary-color);
  letter-spacing: 0.01em;
}

.feed-tag-subtitle {
  margin: 0;
  font-size: 14px;
  color: var(--text-secondary);
}

.feed-tag-feed-link {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  line-height: 1.2;
  padding: 6px 30px 6px 10px;
  min-width: 110px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  margin-left:15px;
}

.feed-tag-feed-link:hover {
  border-color: var(--primary-color);
  background-color: var(--hover-bg);
}

.feed-tag-feed-link:focus {
  outline: 2px solid transparent;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 20%, transparent);
}

.feed-tag-feed-link option {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

.feed-tag-count {
  margin: 0;
  padding: 8px 16px;
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0 0 10px 0;
}

.feed-tag-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 60px 16px;
  color: var(--text-secondary);
  font-size: 15px;
}

.feed-tag-loading p {
  margin: 0;
}

.feed-tag-error {
  padding: 40px 16px;
  text-align: center;
  color: var(--text-secondary);
}

.feed-tag-retry-btn {
  margin-top: 12px;
  padding: 8px 20px;
  background: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
}

.feed-tag-empty {
  padding: 50px 16px;
  text-align: center;
  color: var(--text-secondary);
}

.feed-tag-empty p {
  margin: 0 0 8px 0;
  font-size: 15px;
}

.feed-tag-empty-hint {
  font-size: 13px !important;
  opacity: 0.75;
}

.feed-tag-posts {
  display: flex;
  flex-direction: column;
}

.feed-tag-load-more {
  display: flex;
  justify-content: center;
  padding: 24px 16px 0;
}

.feed-tag-end {
  margin: 0;
  padding: 24px 16px 0;
  text-align: center;
  color: var(--text-secondary);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FeedTagView.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,oFAAoF;EACpF,yDAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,+EAA+E;AACjF;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB","sourcesContent":[".feed-tag-view {\r\n  width: 100%;\r\n  max-width: 600px;\r\n  padding: 0 0 40px 0;\r\n}\r\n\r\n.feed-tag-header {\r\n  padding: 20px 16px 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.sidebar-header-bar .header-title.feed-tag-hashtag {\r\n  margin: 0 !important;\r\n  font-size: 26px;\r\n  font-weight: 800;\r\n  color: var(--primary-color);\r\n  letter-spacing: 0.01em;\r\n}\r\n\r\n.feed-tag-subtitle {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.feed-tag-feed-link {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  background-color: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  line-height: 1.2;\r\n  padding: 6px 30px 6px 10px;\r\n  min-width: 110px;\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%236b7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\r\n  background-repeat: no-repeat;\r\n  background-position: right 10px center;\r\n  margin-left:15px;\r\n}\r\n\r\n.feed-tag-feed-link:hover {\r\n  border-color: var(--primary-color);\r\n  background-color: var(--hover-bg);\r\n}\r\n\r\n.feed-tag-feed-link:focus {\r\n  outline: 2px solid transparent;\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 20%, transparent);\r\n}\r\n\r\n.feed-tag-feed-link option {\r\n  background-color: var(--bg-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.feed-tag-count {\r\n  margin: 0;\r\n  padding: 8px 16px;\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n  margin: 0 0 10px 0;\r\n}\r\n\r\n.feed-tag-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 60px 16px;\r\n  color: var(--text-secondary);\r\n  font-size: 15px;\r\n}\r\n\r\n.feed-tag-loading p {\r\n  margin: 0;\r\n}\r\n\r\n.feed-tag-error {\r\n  padding: 40px 16px;\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.feed-tag-retry-btn {\r\n  margin-top: 12px;\r\n  padding: 8px 20px;\r\n  background: var(--primary-color);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.feed-tag-empty {\r\n  padding: 50px 16px;\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.feed-tag-empty p {\r\n  margin: 0 0 8px 0;\r\n  font-size: 15px;\r\n}\r\n\r\n.feed-tag-empty-hint {\r\n  font-size: 13px !important;\r\n  opacity: 0.75;\r\n}\r\n\r\n.feed-tag-posts {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.feed-tag-load-more {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 24px 16px 0;\r\n}\r\n\r\n.feed-tag-end {\r\n  margin: 0;\r\n  padding: 24px 16px 0;\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
